import { ActionTypes } from "redux/actions/actionType";

// types
import { HomePageTypes } from 'types/types';

export const setHomePageData = ( homePage: HomePageTypes ) => {
    return {
        type: ActionTypes.SET_HOME_PAGE_DATA,
        payload: homePage,
    }
};